<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 17:05:51
 * @LastEditTime: 2019-08-22 10:34:02
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container">
     <div class="pageTitle">把产品卖给消费者时，可通过零售扫描扫描产品上的物流码进行出货，从而把该产品记录为零售出货，方便日后查看产品的零售销售情况；此处可查看零售记录，如需零售出货请登录经销商后台手机端。</div>
           <div class="btnBox">
            <el-button type="primary" @click='showLink=!showLink'>手机端登陆地址</el-button>
        </div>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="零售出货记录" name="1">
                <el-form ref="form" :model="form" label-width="120px" :inline="true">
                    <el-form-item label="零售时间:">
                       <el-col :span="11">
                            <el-date-picker type="date" placeholder="开始时间" v-model="form.start_time"
                                            style="width: 100%;"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-date-picker type="date" placeholder="结束时间" v-model="form.end_time"
                                            style="width: 100%;"></el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="单号:">
                        <el-input v-model="form.keywords" clearable readonly></el-input>
                    </el-form-item>
         
                    <el-form-item>
                        <el-button type="primary" @click="onSearch()">搜索</el-button>
                        <el-button type="primary" @click="onExport()">导出</el-button>

                    </el-form-item>
                </el-form>
        <div style="margin-bottom:10px">总计录: {{total}} ,零售数:{{outstock}}</div>

                <el-table
                        ref="multipleTable"
                        :data="tableData"
                        v-loading="loading"
                        border
                        stripe
                        style="width: 100%;margin: 20px">
                    <el-table-column
                            prop=""
                            label="序号"
                            fixed>
                        <template slot-scope="scope">
                            {{scope.$index}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="stock_out_sn"
                            label="单号"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="real_stock_out_num"
                            label="零售数量"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                    <el-table-column
                            prop="created_at"
                            label="零售时间"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                     <el-table-column
                            prop="remarks"
                            label="备注"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                   
                    <el-table-column
                            prop=""
                            label="操作"
                            width="240"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <a href="JavaScript:;" @click='getDetail(scope.row)'>查看明细</a>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNo"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize">
                </el-pagination>

            </el-tab-pane>
            <el-tab-pane label="零售退货记录" name="2">
         
               <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
                    <el-form-item label="零售时间:">
                       <el-col :span="11">
                            <el-date-picker type="date" placeholder="开始时间" v-model="form1.start_time"
                                            style="width: 100%;"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-date-picker type="date" placeholder="结束时间" v-model="form1.end_time"
                                            style="width: 100%;"></el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="单号:">
                        <el-input v-model="form1.keywords" clearable readonly></el-input>
                    </el-form-item>
         
                    <el-form-item>
                        <el-button type="primary" @click="onSearch()">搜索</el-button>
                        <el-button type="primary" @click="onExport()">导出</el-button>

                    </el-form-item>
                </el-form>
        <div style="margin-bottom:10px">总计录: {{total}} ,退货数:{{outstock}}</div>

                <el-table
                        ref="multipleTable"
                        :data="tableData1"
                        v-loading="loading"
                        border
                        stripe
                        style="width: 100%;margin: 20px">
                    <el-table-column
                            prop=""
                            label="序号"
                            fixed>
                            <template slot-scope="scope">
                                {{scope.$index}}
                            </template>
                    </el-table-column>
                    <el-table-column
                            prop="return_goods_sn"
                            label="单号"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="real_return_goods_num"
                            label="退货数量"
                            show-overflow-tooltip>
                        <template slot-scope="scope">

                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="created_at"
                            label="退货时间"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="remarks"
                            label="备注"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop=""
                            label="操作"
                            width="160"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                       <a href="JavaScript:;" @click='getDetail(scope.row)'>查看明细</a>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="pageNo1"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize1"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize1">
                </el-pagination>

            </el-tab-pane>
        </el-tabs>
        <copyLinkDialog  @handleClose='closeLink' v-if="showLink"/>
                 <el-dialog
                :visible.sync="detail"
                width="50%"
                title='查看明细'
                >
                      <el-button  size="small"    @click="Detailexport()"  style='margin-bottom:10px;' >导出明细</el-button>
                  <el-table
                  :data="tableData2"
                  style="width: 100%"
                  border
                  stripe
                    v-loading="loading"
                 >
                          <el-table-column
                                  prop="stock_out_sn"
                                  label="单号"
                                  >
                          </el-table-column>
                          <el-table-column
                                  prop="created_at"
                                  label="零售时间"
                                >
                          </el-table-column>
                             <el-table-column
                                  prop="product_sn"
                                  label="产品编号"
                                 >
                          </el-table-column>
                          <el-table-column
                                  prop="product_name"
                                  label="产品名称"
                                 >
                          </el-table-column>
                          <el-table-column
                                  prop="product_specs"
                                  label="产品规格"
                                  show-overflow-tooltip>
                          </el-table-column>
                          <el-table-column
                                  prop="real_stock_out_num"
                                  label="零售数量"
                                  >
                          </el-table-column>
                          <el-table-column
                                  prop="logistics_code"
                                  label="物流码"
                                 >
                          </el-table-column>
                          <el-table-column
                                  prop="code_type"
                                  label="标签类型"
                                  fixed="right"
                                 >
                          </el-table-column>
                    </el-table>
                    </el-dialog>
    </div>
</template>

<script>
    import copyLinkDialog from '@/common/copyLinkDialog';

    export default {
        name: "goods-onput",
        data() {
            return {
                loading:false,
                activeName: '1',
                form1:{

                    start_time:"",
                    end_time:"",
                    keywords:""
                },
                form:{
                      start_time:"",
                    end_time:"",keywords:""
                },
                tableData1: [

                ],
                tableData: [

                ],
                tableData2:[],
                //分页
                pageNo1: 1,//页码
                pageSize1: 20,//每页现实的条数
                totalSize1: 0,//总条数
                //分页
                pageNo: 1,//页码
                pageSize: 20,//每页现实的条数
                totalSize: 0,//总条数
                showLink:false,
                total:0,
                outstock:0,
                detailData:{},
                detail:false,
            }
        },
        methods: {
                 getLastMonth() {
                    var now = new Date();
                    var year = now.getFullYear();//getYear()+1900=getFullYear()
                    var month = now.getMonth() + 1;//0-11表示1-12月
                    var day = now.getDate();
                    var dateObj = {};
                    if (parseInt(month) < 10) {
                        month = "0" + month;
                    }
                    if (parseInt(day) < 10) {
                        day = "0" + day;
                    }

                    dateObj.now = year + '-' + month + '-' + day;

                    if (parseInt(month) == 1) {//如果是1月份，则取上一年的12月份
                        dateObj.last = (parseInt(year) - 1) + '-12-' + day;
                        return dateObj;
                    }

                    var preSize = new Date(year, parseInt(month) - 1, 0).getDate();//上月总天数
                    if (preSize < parseInt(day)) {//上月总天数<本月日期，比如3月的30日，在2月中没有30
                        dateObj.last = year + '-' + month + '-01';
                        return dateObj;
                    }

                    if (parseInt(month) <= 10) {
                        dateObj.last = year + '-0' + (parseInt(month) - 1) + '-' + day;
                        return dateObj;
                    } else {
                        dateObj.last = year + '-' + (parseInt(month) - 1) + '-' + day;
                        return dateObj;
                    }

                },
            onSearch(){
                this.loading=true
                if(this.activeName==1){
                      let beginstr = "",
                        endstr = "";
                    if (this.form.start_time) {
                        this.form.start_time = this.moment(this.form.start_time).format("YYYY-MM-DD");
                    }
                    if (this.form.end_time) {
                        this.form.end_time = this.moment(this.form.end_time).format("YYYY-MM-DD");
                    }
                    this.$get('logistics_1','/retail',
                    {
                        ...this.form,
                           per_page: this.pageSize,
                     page: this.pageNo,
                        channel:1,
                        is_export:0
                    }).then(res=>{
                            this.loading = false;
          this.tableData = res.data;
          this.totalSize = res.meta.total;
                 this.total=res.count
                        this.outstock=res.sum
                    })
                }else{
                      let beginstr = "",
                    endstr = "";
                if (this.form1.start_time) {
                    this.form1.start_time = this.moment(this.form1.start_time).format("YYYY-MM-DD");
                }
                if (this.form1.end_time) {
                    this.form1.end_time = this.moment(this.form1.end_time).format("YYYY-MM-DD");
                }
            this.$get('logistics_1','/retail/return',{
                ...this.form1,
                      per_page: this.pageSize1,
                        page: this.pageNo1,
                     channel:1,
                    is_export:0
            }).then(res=>{
                         this.loading = false;
            this.tableData1 = res.data;
            this.totalSize1 = res.meta.total;
                   this.total=res.count
                        this.outstock=res.sum
                    })
                }
            },
            onExport(){
                   let url = '',access_tokens = localStorage.getItem('access_token');
            
                    if(this.activeName==1){
                         let beginstr = "",
                        endstr = "";
                    if (this.form.start_time) {
                        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
                    }
                    if (this.form.end_time) {
                        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
                    }
                 window.open(process.env.VUE_APP_URL_V1
                        +'/retail.export?'+
                       'lang=' + '' +'&is_export=1'+
                      "&start_time=" +
                        beginstr +
                        "&end_time=" +
                        endstr +
                        '&keywords='+this.form.keywords+
                        '&channel=1'
                       +'&signature='+ this.$md5(access_tokens)

                    )
                    }else{
                         let beginstr = "",
                        endstr = "";
                    if (this.form1.start_time) {
                        beginstr = this.moment(this.form1.start_time).format("YYYY-MM-DD");
                    }
                    if (this.form1.end_time) {
                        endstr = this.moment(this.form1.end_time).format("YYYY-MM-DD");
                    }
                window.open(process.env.VUE_APP_URL_V1
                        +'/retail/return.export?'+
                        'lang=' + '' +'&is_export=1'+
                      "&start_time=" +
                        beginstr +
                        "&end_time=" +
                        endstr +
                        '&keywords='+this.form1.keywords+
                        '&channel=1'
                       +'&signature='+ this.$md5(access_tokens)

                    )
                    }
            },
                  getDetail(data){
                    this.loading=true
                    this.detail=true
                    this.detailData=data
                    if(this.activeName==1){
                        var url=''
                        url=encodeURIComponent('/retail/'+data.stock_out_sn+'​/productdata')
              
                                this.$get('logistics_1',decodeURIComponent(url),{
                            is_export:0
                        }).then(res=>{
                            this.tableData2=res.data
                            this.loading=false
                        })
                    }else{
                            this.$get('logistics_1','/retail​/'+data.return_goods_sn+'​/productdata',{
                        is_export:0
                    }).then(res=>{
                        this.tableData2=res.data
                          this.loading=false
                    })
                    }
                
                },
                Detailexport(){
            
                       let url = '',access_tokens = localStorage.getItem('access_token');
                    if(process.env.NODE_ENV == 'development'){
                        url = 'http://dealer.c.qiema.cc/dealer/v1'
                    }else if(process.env.NODE_ENV == 'production'){
                        url = 'http://dealer.api.qiema.cn/dealer/v1';
                    }else{
                        url = 'http://dealer.api.qiema.cn/dealer/v1';
                    }
                      
                    if(this.activeName==1){
                                 window.open(url
                       +'/retail/'+this.detailData.stock_out_sn+'/productdata.export?'+
                        'lang=' + '' +'&is_export=1'+
                        '&keywords='+this.form1.keywords+
                        '&channel=1'
                       +'&signature='+ this.$md5(access_tokens)
                    )
                    }else{
                     window.open(url
                        +'/retail/'+this.detailData.return_goods_sn+'/productdata.export?'+
                       'lang=' + '' +'&is_export=1'+
                       '&signature='+ this.$md5(access_tokens)
                    )
                    }
                },
            handleClick(tab) {
            },
            handleSizeChange1(val) {
                this.pageSize = val;
                this.pageNo = 1;
                //this.getDealerList();
                this.onSearch()

            },
            handleCurrentChange1(val) {
                this.pageNo = val;
                //this.getDealerList();
                this.onSearch()

            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageNo = 1;
                //this.getGoodsList();
                this.onSearch()

            },
            handleCurrentChange(val) {
                this.pageNo = val;
                this.onSearch()
                //this.getGoodsList();
                //this.getGoodsList();
            },
            handleClick(){
                this.onSearch()

            },
              closeLink(){
                //   关闭登陆地址弹窗
            this.showLink=!this.showLink
        }
        },
        created() {
                        this.form.start_time = this.getLastMonth().last;
            this.form.end_time = this.getLastMonth().now;
               this.form1.start_time = this.getLastMonth().last;
            this.form1.end_time = this.getLastMonth().now;
            this.onSearch()
        },

        components: {
        
            copyLinkDialog
        }
    }
</script>

<style lang="scss" scoped>
    .block{
        height: 100px;
        line-height: 24px;
        background-color: #eee;
        padding-left: 20px;
        margin-bottom: 20px;
    }

</style>